import React from 'react';
import styled from 'styled-components';
import { animationFixStyle } from 'components/Common';
import AbstractToggle from './AbstractToggle';

const StyledToggle = styled.input`
  appearance: none;
  background: ${({ checked }) => (checked ? '#4cd964;' : '#e5e5e5;')};
  border: none;
  border-radius: 28px;
  box-sizing: border-box;
  cursor: pointer;
  height: 25px;
  margin: 0;
  outline: none;
  padding: 0;
  position: relative;
  transition-duration: 0.3s;
  width: 36px;
  z-index: 0;
  ${animationFixStyle}
  &:after {
    background: #fff;
    border-radius: 17px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
    content: ' ';
    height: 20px;
    left: 5px;
    position: absolute;
    top: 2px;
    transform: ${({ checked }) =>
      checked ? 'translateX(9px)' : 'translateX(0)'};
    transition-duration: 0.3s;
    width: 19px;
    z-index: 2;
    ${animationFixStyle}
  }
`;

export default class Slider extends AbstractToggle {
  render() {
    return (
      <StyledToggle
        type="checkbox"
        checked={this.props.checked}
        onChange={this.onChange}
      />
    );
  }
}
